import { createAsyncAction } from 'typesafe-actions';
import { GlobalErrorDialogResponse } from 'GlobalErrorDialog-Types';

export const fetchGlobalErrorDialogAsync = createAsyncAction(
  'FETCH_GLOBAL_ERROR_DIALOG_REQUEST',
  'FETCH_GLOBAL_ERROR_DIALOG_SUCCESS',
  'FETCH_GLOBAL_ERROR_DIALOG_FAILURE',
)<undefined, GlobalErrorDialogResponse, GlobalErrorDialogResponse>();
